import React from 'react';

export const HotjarMaskert: React.FC<{
    children?: React.ReactNode;
}> = ({ children }) => <span data-hj-suppress={true}>{children}</span>;
